// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__2Lsla","row--secondary":"Row_row--secondary__1H7DM"};